import { OKTA_TOKEN_STORAGE_KEY } from '@/utils/constants/globalConstants'

export const useOktaStorage = () => {
  const oktaTokenStorage = localStorage.getItem(OKTA_TOKEN_STORAGE_KEY)
  const tokenData = oktaTokenStorage ? JSON.parse(oktaTokenStorage) : null

  return {
    ...tokenData,
    claims: tokenData?.accessToken?.claims || {},
  }
}